import { postRequest } from 'src/services/requests';
import direitos from '../global/constants/direitos';
import { DireitosDTO } from '../types/dtos/genericos';

const loadDireitos = async (
  direitosParaValidar: string[],
  salvarLocalStorage = false
): Promise<string[]> => {
  const allDireitos = Array.from(new Set(direitosParaValidar)).filter(Boolean);

  if (!allDireitos.length) {
    return [];
  }

  const data = {
    Direitos: allDireitos,
  };

  const responseDireitos = new Promise<DireitosDTO[]>((resolve, reject) => {
    postRequest(
      '/genericos/ge/direito/CarregarDireitos',
      data,
      resolve,
      reject
    );
  });

  return responseDireitos.then(response => {
    if (response.length) {
      const direitosPermitidos = response
        .filter(direito => direito.Possui)
        .map(direito => direito.Chave);

      if (salvarLocalStorage) {
        localStorage.setItem('direitos', JSON.stringify(direitosPermitidos));
      }

      return direitosPermitidos;
    }

    return [];
  });
};

const loadAllDireitos = async (): Promise<string[]> => {
  return loadDireitos(direitos, true);
};

export { loadAllDireitos, loadDireitos };
